"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.inlineCSSDocument = inlineCSSDocument;
exports.inlineCSSHtml = inlineCSSHtml;
exports.stripBodyStyle = exports.juice = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
//todo: remove default css property value
function inlineMediaRule(doc, rule) {
  var mediaQuery = window.matchMedia(rule.conditionText);
  if (mediaQuery.matches) {
    inlineCssRules(doc, rule.cssRules);
  }
}
function inlineStyleRule(doc, rule) {
  // webkit css prefix will trigger error in safari
  try {
    doc.querySelectorAll(rule.selectorText).forEach(function (node) {
      node.customStyle = (node.customStyle || '') + rule.style.cssText;
    });
  } catch (e) {
    console.error(e);
  }
}
function inlineCssRules(doc, cssRules) {
  var total = cssRules.length;
  for (var index = 0; index < total; index++) {
    var rule = cssRules[index];
    if (rule.type === CSSRule.STYLE_RULE && rule.selectorText) {
      rule.style.cssText && inlineStyleRule(doc, rule);
    } else if (rule.type === CSSRule.MEDIA_RULE) {
      rule.cssRules.length && inlineMediaRule(doc, rule);
    }
  }
}
var juice = exports.juice = function juice(doc) {
  //just inline all style rule first
  ;
  (0, _toConsumableArray2["default"])(doc.querySelectorAll('style')).forEach(function (node) {
    if (node.sheet && node.sheet.cssRules) {
      ;
      (0, _toConsumableArray2["default"])(node.sheet.cssRules).filter(function (rule) {
        return rule.type === CSSRule.STYLE_RULE;
      }).forEach(function (rule) {
        return inlineStyleRule(doc, rule);
      });
    }
  })

  //media rule has higher priority than style rule
  ;
  (0, _toConsumableArray2["default"])(doc.querySelectorAll('style')).forEach(function (node) {
    if (node.sheet && node.sheet.cssRules) {
      ;
      (0, _toConsumableArray2["default"])(node.sheet.cssRules).filter(function (rule) {
        return rule.type === CSSRule.MEDIA_RULE;
      }).forEach(function (rule) {
        return inlineMediaRule(doc, rule);
      });
    }
  });
  (0, _toConsumableArray2["default"])(doc.querySelectorAll('style')).forEach(function (node) {
    return node.remove();
  });
  doc.querySelectorAll('*').forEach(function (node) {
    if (node.customStyle) {
      node.style.cssText = node.customStyle + node.style.cssText;
    }
  });
};
var stripBodyStyle = exports.stripBodyStyle = function stripBodyStyle(doc) {
  var body = doc.body;
  if (body.hasAttribute('style')) {
    var style = body.getAttribute('style');
    var div = doc.createElement('div');
    div.innerHTML = body.innerHTML;
    div.setAttribute('style', style);
    return div.outerHTML;
  } else {
    return body.innerHTML;
  }
};
function inlineCSSDocument(doc) {
  if (doc.querySelector('style')) {
    juice(doc);
  }
  return stripBodyStyle(doc);
}
function inlineCSSHtml(html) {
  if (html.includes('</style>')) {
    var domParser = new DOMParser();
    var doc = domParser.parseFromString(html, 'text/html');
    juice(doc);
    return stripBodyStyle(doc);
  } else if (html.includes('</body>')) {
    var _domParser = new DOMParser();
    var _doc = _domParser.parseFromString(html, 'text/html');
    return stripBodyStyle(_doc);
  }
  return html;
}
//# sourceMappingURL=inlineCSS.js.map